import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  placeholderPadding: {
    paddingBottom: '8px',
  },
  placeholderTopSection: {
    padding: '15px 24px 5px',
  },
  placeholderBottomSection: {
    height: '68px',
    borderTop: `1px solid ${colors.gray.l94}`,
  },
});
